import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from 'components/button';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';

export default class AdvisoryHeader extends Component {

  constructor() {
    super();

    this.backHandler = this.backHandler.bind(this);
    this.closeHandler = this.closeHandler.bind(this);
  }

  /* Handlers */

  backHandler() {
    if (this.props.backHandler) this.props.backHandler();
    browserHistory.goBack();
  }

  closeHandler() {
    this.props.appModalOpen({
      component: <FormattedMessage id="advisory.detail.leaveConfirmation" />,
      onCancel: () => {},
      onConfirm: () => { browserHistory.push('/advisory-tool'); },
      title: <FormattedMessage id="advisory.detail.leaveTitle" />,
      type: 'confirm',
    });
  }

  /* Render */

  render() {
    return (
      <div className="view__header">
        <div className="header">
          <div className="header__inner">
            <div className="align align--fluid align--gutter-sm">
              <div className="align__cell align__cell--shrink">
                <Button
                  className="button"
                  onClick={this.backHandler}
                >
                  <span className="icon icon-arrow-left icon--md" />
                </Button>
              </div>
              <div className="align__cell">
                <h1 className="header__title header__title--no-spacing u-text-center">
                  <FormattedMessage id="advisory.detail.title" />
                </h1>
              </div>
              <div className="align__cell align__cell--shrink">
                <Button
                  className="button"
                  onClick={this.closeHandler}
                >
                  <span className="icon icon-close icon--md" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AdvisoryHeader.propTypes = {
  appModalOpen: PropTypes.func,
  backHandler: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/components/advisory-header/index.jsx